import { MaxSearchResultCount, universalSearchResultItem, useUniversalSearch } from "Shared/UniversalSearch";

import { isValidGuid } from "Shared/Utils/isValidGuid";
import { useCallback } from "react";
import { useNavigate } from "react-router";
import { useORPCClient } from "Core/oRPC";
import { getServiceDetailLink } from "../ServiceRoutes";
import { AppRegistry } from "Apps/AppRegistry";

export const useSearchService = () => {
    const navigate = useNavigate();

    const { shasApi } = useORPCClient();

    const searchService = useCallback(
        async (word: string) => {
            if (!word) {
                return [];
            }

            const resultList: universalSearchResultItem[] = [];
            if (isValidGuid(word)) {
                const response = await shasApi.postGetServicesByIds({ Ids: [word] });
                const services = response.Data;
                services.forEach((service) => {
                    if (service.ServiceId && service.Name) {
                        const link = getServiceDetailLink(service.ServiceId);
                        resultList.push({
                            id: service.ServiceId,
                            title: service.Name,
                            description: service.ServiceId,
                            onClick: () => navigate(link),
                            navigationTarget: link
                        });
                    }
                });
            } else {
                const services = await shasApi.getSearchService({ searchString: word });
                services.forEach((service) => {
                    if (service.Id && service.Name) {
                        const link = getServiceDetailLink(service.Id);
                        resultList.push({
                            id: service.Id,
                            title: service.Name,
                            description: service.Id,
                            onClick: () => navigate(link),
                            navigationTarget: link
                        });
                    }
                });
            }

            return resultList.length > MaxSearchResultCount ? resultList.slice(0, MaxSearchResultCount) : resultList;
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [navigate]
    );

    useUniversalSearch("Services", "services", searchService, false, AppRegistry.Service.path);
};
